<template>
  <div class="home">
    <!-- <Header /> -->
    <q-responsive  v-if="$q.screen.lt.sm" :ratio="16/9" style="width: 100%; max-width: 100%;">
      <q-carousel animated
        v-model="slide"
        infinite
        :autoplay="autoplay"
        arrows
        transition-prev="slide-right"
        transition-next="slide-left"
        @mouseenter="autoplay = false"
        @mouseleave="autoplay = true"
        control-color="purple-12"
        swipeable
      >
        <q-carousel-slide v-for="(data, index ) in list_banner" :name="index+1" :img-src="file_path+data.file" />
          <!-- <div class="absolute-center custom-caption">
            <div class="text-h6" style="text-shadow: #C039FF;">{{ data.judul }}</div>
            <div class="text-subtitle6" style="text-shadow: #C039FF;">{{ data.keterangan }}</div>
          </div>
        </q-carousel-slide> -->
      </q-carousel>
    </q-responsive>
      <q-carousel v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl"
        animated
        v-model="slide"
        navigation
        infinite
        :autoplay="autoplay"
        arrows
        transition-prev="slide-right"
        transition-next="slide-left"
        @mouseenter="autoplay = false"
        @mouseleave="autoplay = true"
        height="750px"
        max-height="100%"
        control-color="purple-12"
        swipeable
        style="margin-bottom: 25px;"
      >
        <q-carousel-slide v-for="(data, index ) in list_banner" :name="index+1" :img-src="file_path+data.file" />
          <!-- <div class="absolute-bottom custom-caption">
            <div class="text-h2" style="text-shadow: #C039FF;">{{ data.judul }}</div>
            <div class="text-subtitle1" style="text-shadow: #C039FF;">{{ data.keterangan }}</div>
          </div> -->
        <!-- </q-carousel-slide> -->
        <!-- <q-carousel-slide name="second" img-src="https://cdn.quasar.dev/img/parallax1.jpg">
          <div class="absolute-bottom custom-caption">
            <div class="text-h2">Second stop</div>
            <div class="text-subtitle1">Famous City</div>
          </div>
        </q-carousel-slide>
        <q-carousel-slide name="third" img-src="https://cdn.quasar.dev/img/parallax2.jpg">
          <div class="absolute-bottom custom-caption">
            <div class="text-h2">Third stop</div>
            <div class="text-subtitle1">Famous Bridge</div>
          </div>
        </q-carousel-slide> -->
      </q-carousel>
    <div class="row" style="margin: 50px 90px;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="col-12 col-md-4 banner-pad">
        <q-img src="img/banner-1.png" style="border-radius: 10px;">
          <div class="col absolute-full">
            <div class="banner-text">
              Hasil Perkebunan Segar Konawe Selatan
            </div>
            <div>
              <q-btn to="/produk" no-caps color="purple-12" class="absolute banner-btn" label="Beli Sekarang" />
            </div>
          </div>
          <template v-slot:loading>
            <div class="text-purple-12">
              <q-spinner-ios />
            </div>
          </template>
        </q-img>
      </div>
      <div class="col-12 col-md-4 banner-pad">
        <q-img src="img/banner-2.png" style="border-radius: 10px;">
          <div class="col absolute-full">
            <div class="banner-text">
              Kerajinan Tangan Terbaik Konawe Selatan
            </div>
            <div>
              <q-btn to="/produk" no-caps color="purple-12" class="absolute banner-btn" label="Beli Sekarang" />
            </div>
          </div>
          <template v-slot:loading>
            <div class="text-purple-12">
              <q-spinner-ios />
            </div>
          </template>
        </q-img>
      </div>
      <div class="col-12 col-md-4 banner-pad">
        <q-img src="img/banner-3.png" style="border-radius: 10px;">
          <div class="col absolute-full">
            <div class="banner-text">
              Olahan Pangan Organik Konawe Selatan
            </div>
            <div>
              <q-btn to="/produk" no-caps color="purple-12" class="absolute banner-btn" label="Beli Sekarang" />
            </div>
          </div>
          <template v-slot:loading>
            <div class="text-purple-12">
              <q-spinner-ios />
            </div>
          </template>
        </q-img>
      </div>
    </div>
    <div class="row" style="margin: 25px 10px;" v-if="$q.screen.lt.sm">
      <div class="col-4 banner-pad-android">
        <q-img src="img/banner-1.png" style="border-radius: 10px;">
          <div class="col absolute-full">
            <div class="banner-text-android">
              Hasil Perkebunan Segar Konawe Selatan
            </div>
            <div>
              <q-btn to="/produk" round color="purple-12" class="absolute banner-btn-android" size="xs" icon="sym_o_shopping_bag" />
            </div>
          </div>
          <template v-slot:loading>
            <div class="text-purple-12">
              <q-spinner-ios />
            </div>
          </template>
        </q-img>
      </div>
      <div class="col-4 banner-pad-android">
        <q-img src="img/banner-2.png" style="border-radius: 10px;">
          <div class="col absolute-full">
            <div class="banner-text-android">
              Kerajinan Tangan Terbaik Konawe Selatan
            </div>
            <div>
              <q-btn to="/produk" round color="purple-12" class="absolute banner-btn-android" size="xs" icon="sym_o_shopping_bag" />
            </div>
          </div>
          <template v-slot:loading>
            <div class="text-purple-12">
              <q-spinner-ios />
            </div>
          </template>
        </q-img>
      </div>
      <div class="col-4 banner-pad-android">
        <q-img src="img/banner-3.png" style="border-radius: 10px;">
          <div class="col absolute-full">
            <div class="banner-text-android">
              Olahan Pangan Organik Konawe Selatan
            </div>
            <div>
              <q-btn to="/produk" round color="purple-12" class="absolute banner-btn-android" size="xs" icon="sym_o_shopping_bag" />
            </div>
          </div>
          <template v-slot:loading>
            <div class="text-purple-12">
              <q-spinner-ios />
            </div>
          </template>
        </q-img>
      </div>
    </div>
    <div style="margin: 25px 100px 50px" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row" style="margin-bottom: 25px;">
        <div class="col-12 col-md-2 produk-title1">
          Produk Terbaru
        </div>
        <!-- <q-space /> -->
        <div class="col-12 col-md-10">
          <q-tabs
          v-model="tabs"
          shrink
          stretch
          dense
          align="left"
          outside-arrows
          mobile-arrows
          inline-label
          active-color="purple-12"
          class="text-dark-10"
        >
          <q-tab dense no-caps style="font-family: 'Quicksand';" name="all" label="Semua Kategori" />
          <q-tab dense no-caps style="font-family: 'Quicksand';" v-for="data in list_kategori" :name="data.id" :label="data.uraian" @click="getKategoriProduk(data.id)" />
        </q-tabs>
        </div>
      </div>
      <q-tab-panels v-model="tabs" animated>
        <q-tab-panel name="all">
          <div class="row items-start q-col-gutter-md">
            <div class="col-12 col-md-3" v-for="data in all_produk">
              <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                <q-img :src="file_path+data.file" height="275px">
                  <template v-slot:loading>
                    <div class="text-purple-12">
                      <q-spinner-ios />
                    </div>
                  </template>
                </q-img>

                <q-card-section style="text-align: center;">
                  <q-btn
                    round
                    color="white"
                    icon="shopping_cart"
                    text-color="purple-12"
                    size="sm"
                    style="top: -15px; transform: translateY(-50%);"
                  ><q-tooltip
                      transition-show="flip-right"
                      transition-hide="flip-left"
                      class="bg-purple-12 text-white"
                    >
                      Lihat Produk
                    </q-tooltip>
                  </q-btn>
                  <div class="produk-cat">
                    {{data.kategori_uraian}}
                  </div>
                  <div style="padding-bottom: 15px;">
                    <q-rating
                    v-model="model1"
                    max="5"
                    size="1em"
                    color="purple-12"
                    icon="star_border"
                    icon-selected="star"
                    icon-half="star_half"
                  />
                  </div>
                  <q-btn no-caps flat @click="push_produk(data.id)" style="font-family: 'Poppins'; font-size: 16px; font-weight: 600; color: #2B2B2D; padding-bottom: 15px;" class="btn--no-hover" :label="data.brand">
                    <!-- <q-tooltip
                      transition-show="flip-right"
                      transition-hide="flip-left"
                      class="bg-purple-12 text-white"
                    >
                      Lihat Produk
                    </q-tooltip> -->
                  </q-btn>
                  <div v-if="data.diskon == null || data.diskon == 0" class="produk-price1">Rp. {{data.harga}}</div>
                  <div v-else class="produk-price1">Rp. {{data.harga - (data.harga * data.diskon / 100)}} <span class="produk-price2"> Rp. {{data.harga}}</span></div>
                </q-card-section>
                
              </q-card>
            </div>
          </div>
        </q-tab-panel>

        <q-tab-panel v-for="data in list_kategori" :name="data.id">
          <div class="row items-start q-col-gutter-md">
            <div class="col-12 col-md-3" v-for="data in kategori_produk">
              <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                <q-img :src="file_path+data.file" height="275px">
                  <template v-slot:loading>
                    <div class="text-purple-12">
                      <q-spinner-ios />
                    </div>
                  </template>
                </q-img>

                <q-card-section style="text-align: center;">
                  <q-btn
                    round
                    color="white"
                    icon="shopping_cart"
                    text-color="purple-12"
                    size="sm"
                    style="top: -15px; transform: translateY(-50%);"
                  />
                  <div class="produk-cat">
                    {{data.kategori_uraian}}
                  </div>
                  <div style="padding-bottom: 15px;">
                    <q-rating
                    v-model="model1"
                    max="5"
                    size="1em"
                    color="purple-12"
                    icon="star_border"
                    icon-selected="star"
                    icon-half="star_half"
                  />
                  </div>
                  <q-btn no-caps flat @click="push_produk(data.id)" style="font-family: 'Poppins'; font-size: 16px; font-weight: 600; color: #2B2B2D; padding-bottom: 15px;" class="btn--no-hover" :label="data.brand" />
                  <div v-if="data.diskon == null || data.diskon == 0" class="produk-price1">Rp. {{data.harga}}</div>
                  <div v-else class="produk-price1">Rp. {{data.harga - (data.harga * data.diskon / 100)}} <span class="produk-price2"> Rp. {{data.harga}}</span></div>
                </q-card-section>
                
              </q-card>
            </div>
          </div>
        </q-tab-panel>
      </q-tab-panels>
    </div>  
    <div v-if="$q.screen.lt.sm">
      <div class="row" style="margin: 10px 20px 7.5px;">
        <div class="col-12 produk-title1-android">
          Produk Terbaru
        </div>
        <!-- <q-space /> -->
        <div class="col-12">
          <q-tabs
          v-model="tabs"
          shrink
          stretch
          dense
          align="right"
          active-color="purple-12"
          class="text-dark-10"
        >
          <q-tab no-caps name="all">
            <div class="tab-android">
              Semua Kategori
            </div>
          </q-tab>
          <q-tab no-caps v-for="data in list_kategori" :name="data.id" @click="getKategoriProduk(data.id)">
            <div class="tab-android">
              {{ data.uraian }}
            </div>
            </q-tab>
        </q-tabs>
        </div>
      </div>
      <div style="margin: 0 5px 10px">
      <q-tab-panels v-model="tabs" animated>
        <q-tab-panel name="all">
          <div class="row items-start q-col-gutter-xs">
            <div class="col-3" v-for="data in all_produk">
              <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                <q-img :src="file_path+data.file" height="100px">
                  <template v-slot:loading>
                    <div class="text-purple-12">
                      <q-spinner-ios />
                    </div>
                  </template>
                </q-img>

                <q-card-section style="text-align: center;">
                  <q-btn
                    round
                    color="white"
                    icon="shopping_cart"
                    text-color="purple-12"
                    size="xs"
                    style="top: -15px; transform: translateY(-50%);"
                  />
                  <div class="produk-cat-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;">
                    {{data.kategori_uraian}}
                  </div>
                  <div style="margin-top: -5px;">
                    <q-rating
                    v-model="model1"
                    max="5"
                    size="0.5em"
                    color="purple-12"
                    icon="star_border"
                    icon-selected="star"
                    icon-half="star_half"
                  />
                  </div>
                  <div class="text-center text-no-wrap overflow-hidden produk-android-title" style="text-overflow: ellipsis;">
                        {{ data.brand }}
                      </div>
                      <div v-if="data.diskon == null || data.diskon == 0" class="produk-price1-android">Rp. {{data.harga}}</div>
                      <div v-else class="produk-price1-android">Rp. {{data.harga - (data.harga * data.diskon / 100)}} <span class="produk-price2-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;"> Rp. {{data.harga}}</span></div>
                </q-card-section>
                
              </q-card>
            </div>
          </div>
        </q-tab-panel>

        <q-tab-panel v-for="data in list_kategori" :name="data.id">
          <div class="row items-start q-col-gutter-xs">
            <div class="col-3" v-for="data in kategori_produk">
              <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                <q-img :src="file_path+data.file" height="100px">
                  <template v-slot:loading>
                    <div class="text-purple-12">
                      <q-spinner-ios />
                    </div>
                  </template>
                </q-img>

                <q-card-section style="text-align: center;">
                  <q-btn
                    round
                    color="white"
                    icon="shopping_cart"
                    text-color="purple-12"
                    size="sm"
                    style="top: -15px; transform: translateY(-50%);"
                  />
                  <div class="produk-cat-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;">
                    {{data.kategori_uraian}}
                  </div>
                  <div style="margin-top: -5px;">
                    <q-rating
                    v-model="model1"
                    max="5"
                    size="0.5em"
                    color="purple-12"
                    icon="star_border"
                    icon-selected="star"
                    icon-half="star_half"
                  />
                  </div>
                  <div class="text-center text-no-wrap overflow-hidden produk-android-title" style="text-overflow: ellipsis;">
                        {{ data.brand }}
                      </div>
                      <div v-if="data.diskon == null || data.diskon == 0" class="produk-price1-android">Rp. {{data.harga}}</div>
                      <div v-else class="produk-price1-android">Rp. {{data.harga - (data.harga * data.diskon / 100)}} <span class="produk-price2-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;"> Rp. {{data.harga}}</span></div>
                </q-card-section>
                
              </q-card>
            </div>
          </div>
        </q-tab-panel>
      </q-tab-panels>
    </div>
    </div>  
    <div class="row text-center" style="margin: 0 90px; padding: 50px 0; border-style: solid none solid none; border-width: 1px; border-color: #E9E9E9;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="col-12 col-md-3" style="padding: 5px 10px">
        <q-card flat bordered class="my-card package-area">

          <q-card-section>
            <div class="package-icon"><span class="material-symbols-outlined">package_2</span></div>
          </q-card-section>

          <q-separator flat inset />

          <q-card-section>
            <div class="package-title1">Pengemasan Produk</div>
            <div class="package-title2">Marina Market-Place</div>
          </q-card-section>

        </q-card>
      </div>
      <div class="col-12 col-md-3" style="padding: 5px 10px">
        <q-card flat bordered class="my-card package-area">

          <q-card-section>
            <div class="package-icon"><span class="material-symbols-outlined">phone_in_talk</span></div>
          </q-card-section>

          <q-separator flat inset />

          <q-card-section>
            <div class="package-title1">24X7 Bantuan</div>
            <div class="package-title2">Marina Market-Place</div>
          </q-card-section>

        </q-card>
      </div>
      <div class="col-12 col-md-3" style="padding: 5px 10px">
        <q-card flat bordered class="my-card package-area">

          <q-card-section>
            <div class="package-icon"><span class="material-symbols-outlined">local_shipping</span></div>
          </q-card-section>

          <q-separator flat inset />

          <q-card-section>
            <div class="package-title1">Pengiriman Cepat</div>
            <div class="package-title2">Marina Market-Place</div>
          </q-card-section>

        </q-card>
      </div>
      <div class="col-12 col-md-3" style="padding: 5px 10px">
        <q-card flat bordered class="my-card package-area">

          <q-card-section>
            <div class="package-icon"><span class="material-symbols-outlined">payments</span></div>
          </q-card-section>

          <q-separator flat inset />

          <q-card-section>
            <div class="package-title1">Pembayaran Aman</div>
            <div class="package-title2">Marina Market-Place</div>
          </q-card-section>

        </q-card>
      </div>
    </div>
    <div class="row text-center" v-if="$q.screen.lt.sm" style="margin: 0 20px; padding: 20px 0; border-style: solid none solid none; border-width: 1px; border-color: #E9E9E9;">
      <div class="col-3" style="padding: 5px 1.5px">
        <q-card flat bordered class="my-card package-area">

          <q-card-section>
            <div class="package-icon-android"><span class="material-symbols-outlined">package_2</span></div>
          </q-card-section>

          <q-separator flat inset />

          <q-card-section>
            <div class="package-title1-android">Pengemasan Baik</div>
            <div class="package-title2-android">Marina Market-Place</div>
          </q-card-section>

        </q-card>
      </div>
      <div class="col-3" style="padding: 5px 1.5px">
        <q-card flat bordered class="my-card package-area">

          <q-card-section>
            <div class="package-icon-android"><span class="material-symbols-outlined">phone_in_talk</span></div>
          </q-card-section>

          <q-separator flat inset />

          <q-card-section>
            <div class="package-title1-android">24X7 Bantuan</div>
            <div class="package-title2-android">Marina Market-Place</div>
          </q-card-section>

        </q-card>
      </div>
      <div class="col-3" style="padding: 5px 1.5px">
        <q-card flat bordered class="my-card package-area">

          <q-card-section>
            <div class="package-icon-android"><span class="material-symbols-outlined">local_shipping</span></div>
          </q-card-section>

          <q-separator flat inset />

          <q-card-section>
            <div class="package-title1-android">Pengiriman Cepat</div>
            <div class="package-title2-android">Marina Market-Place</div>
          </q-card-section>

        </q-card>
      </div>
      <div class="col-3" style="padding: 5px 1.5px">
        <q-card flat bordered class="my-card package-area">

          <q-card-section>
            <div class="package-icon-android"><span class="material-symbols-outlined">payments</span></div>
          </q-card-section>

          <q-separator flat inset />

          <q-card-section>
            <div class="package-title1-android">Pembayaran Aman</div>
            <div class="package-title2-android">Marina Market-Place</div>
          </q-card-section>

        </q-card>
      </div>
    </div>
    <div style="margin: 50px 100px 100px;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row">
        <div class="col-12 col-md-6 produk-title1">
          Produk Populer
        </div>
        <div class="col-12 col-md-6" style="text-align: right;">
          <q-btn to="/produk" flat no-caps color="purple-12">
            <div class="produk-title2">Lihat Semua Produk</div>
            <div class="produk-btn">
              <span class="material-symbols-outlined">
                arrow_right_alt
              </span>
            </div>
        </q-btn>
        </div>
      </div>
      <div class="row" style="margin-top: 25px;">
        <div class="col-12 col-md-2" style="padding-top: 16px;">
          <q-tabs
            v-model="tab"
            vertical
            inline-label
            dense
            active-color="purple-12"
            class="text-dark-10"
            >
            <q-tab no-caps class="produk-tabs" style="justify-content: initial;" label="Semua Kategori" name="all" />
            <q-tab no-caps v-for="data in list_kategori" @click="getKategoriPopuler(data.id)" class="produk-tabs" style="justify-content: initial;" :label="data.uraian" :name="data.id"/>
          </q-tabs>
        </div>
        <div class="col-12 col-md-10">
          <q-tab-panels
            v-model="tab"
            animated
            transition-prev="jump-up"
            transition-next="jump-up"
          >
            <q-tab-panel name="all">
              <div class="row items-start q-col-gutter-md">
                <div class="col-12 col-md-4" v-for="data in produk_populer">
                  <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                    <q-img :src="file_path+data.file" height="275px">
                      <template v-slot:loading>
                        <div class="text-purple-12">
                          <q-spinner-ios />
                        </div>
                      </template>
                    </q-img>

                    <q-card-section style="text-align: center;">
                      <q-btn
                        round
                        color="white"
                        icon="shopping_cart"
                        text-color="purple-12"
                        size="sm"
                        style="top: -15px; transform: translateY(-50%);"
                      />
                      <div class="produk-cat">
                        {{data.kategori_uraian}}
                      </div>
                      <div style="padding-bottom: 15px;">
                        <q-rating
                        v-model="model1"
                        max="5"
                        size="1em"
                        color="purple-12"
                        icon="star_border"
                        icon-selected="star"
                        icon-half="star_half"
                      />
                      </div>
                      <q-btn no-caps flat @click="push_produk(data.id)" style="font-family: 'Poppins'; font-size: 16px; font-weight: 600; color: #2B2B2D; padding-bottom: 15px;" class="btn--no-hover" :label="data.brand" />
                      <div v-if="data.diskon == null || data.diskon == 0" class="produk-price1">Rp. {{data.harga}}</div>
                      <div v-else class="produk-price1">Rp. {{data.harga - (data.harga * data.diskon / 100)}} <span class="produk-price2"> Rp. {{data.harga}}</span></div>
                    </q-card-section>
                    
                  </q-card>
                </div>
              </div>
            </q-tab-panel>

            <q-tab-panel v-for="data in list_kategori" :name="data.id">
              <div class="row items-start q-col-gutter-md">
                <div class="col-12 col-md-4" v-for="data in kategori_populer">
                  <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                    <q-img :src="file_path+data.file" height="275px">
                      <template v-slot:loading>
                        <div class="text-purple-12">
                          <q-spinner-ios />
                        </div>
                      </template>
                    </q-img>

                    <q-card-section style="text-align: center;">
                      <q-btn
                        round
                        color="white"
                        icon="shopping_cart"
                        text-color="purple-12"
                        size="sm"
                        style="top: -15px; transform: translateY(-50%);"
                      />
                      <div class="produk-cat">
                        {{data.kategori_uraian}}
                      </div>
                      <div style="padding-bottom: 15px;">
                        <q-rating
                        v-model="model1"
                        max="5"
                        size="1em"
                        color="purple-12"
                        icon="star_border"
                        icon-selected="star"
                        icon-half="star_half"
                      />
                      </div>
                      <q-btn no-caps flat @click="push_produk(data.id)" style="font-family: 'Poppins'; font-size: 16px; font-weight: 600; color: #2B2B2D; padding-bottom: 15px;" class="btn--no-hover" :label="data.brand" />
                      <div v-if="data.diskon == null || data.diskon == 0" class="produk-price1">Rp. {{data.harga}}</div>
                      <div v-else class="produk-price1">Rp. {{data.harga - (data.harga * data.diskon / 100)}} <span class="produk-price2"> Rp. {{data.harga}}</span></div>
                    </q-card-section>
                    
                  </q-card>
                </div>
              </div>
            </q-tab-panel>
          </q-tab-panels>
        </div>
      </div>
    </div>
    <div style="margin: 10px 20px;" v-if="$q.screen.lt.sm">
      <div class="row">
        <div class="col-6 produk-title1-android">
          Produk Populer
        </div>
        <div class="col-6" style="text-align: right;">
          <q-btn to="/produk" flat no-caps color="purple-12" style="margin-top: -10px; margin-right: -15px;">
            <div class="produk-title2-android">Lihat Semua Produk</div>
            <div class="produk-btn-android">
              <span class="material-symbols-outlined">
                arrow_right_alt
              </span>
            </div>
        </q-btn>
        </div>
      </div>
      <div class="row" style="margin: -10px -12.5px 0 -7.5px">
        <div class="col-3" style="padding-top: 16px;">
          <q-tabs
            v-model="tab"
            vertical
            dense
            inline-label
            active-color="purple-12"
            class="text-dark-10"
            >
            <q-tab no-caps style="justify-content: initial;" name="all">
              <div class="tabs-android">
                Semua Kategori
              </div>
            </q-tab>
            <q-tab no-caps v-for="data in list_kategori" @click="getKategoriPopuler(data.id)" style="justify-content: initial;" :name="data.id">
              <div class="tabs-android">
                {{data.uraian}}
              </div>
            </q-tab>
          </q-tabs>
        </div>
        <div class="col-9">
          <q-tab-panels
            v-model="tab"
            animated
            transition-prev="jump-up"
            transition-next="jump-up"
          >
            <q-tab-panel name="all">
              <div class="row items-start q-col-gutter-xs">
                <div class="col-4" v-for="data in produk_populer">
                  <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                    <q-img :src="file_path+data.file" height="100px">
                      <template v-slot:loading>
                        <div class="text-purple-12">
                          <q-spinner-ios />
                        </div>
                      </template>
                    </q-img>

                    <q-card-section style="text-align: center;">
                      <q-btn
                        round
                        color="white"
                        icon="shopping_cart"
                        text-color="purple-12"
                        size="xs"
                        style="top: -15px; transform: translateY(-50%);"
                        @click="push_produk(data.id)"
                      />
                      <div class="produk-cat-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;">
                    {{data.kategori_uraian}}
                  </div>
                  <div style="margin-top: -5px;">
                        <q-rating
                        v-model="model1"
                        max="5"
                        size="0.5em"
                        color="purple-12"
                        icon="star_border"
                        icon-selected="star"
                        icon-half="star_half"
                      />
                      </div>
                      <div class="text-center text-no-wrap overflow-hidden produk-android-title" style="text-overflow: ellipsis;">
                        {{ data.brand }}
                      </div>
                      <div v-if="data.diskon == null || data.diskon == 0" class="produk-price1-android">Rp. {{data.harga}}</div>
                      <div v-else class="produk-price1-android">Rp. {{data.harga - (data.harga * data.diskon / 100)}} <span class="produk-price2-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;"> Rp. {{data.harga}}</span></div>
                    </q-card-section>
                    
                  </q-card>
                </div>
              </div>
            </q-tab-panel>

            <q-tab-panel v-for="data in list_kategori" :name="data.id">
              <div class="row items-start q-col-gutter-xs">
                <div class="col-4" v-for="data in kategori_populer">
                  <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                    <q-img :src="file_path+data.file" height="100px">
                      <template v-slot:loading>
                        <div class="text-purple-12">
                          <q-spinner-ios />
                        </div>
                      </template>
                    </q-img>

                    <q-card-section style="text-align: center;">
                      <q-btn
                        round
                        color="white"
                        icon="shopping_cart"
                        text-color="purple-12"
                        size="xs"
                        style="top: -15px; transform: translateY(-50%);"
                        @click="push_produk(data.id)"
                      />
                      <div class="produk-cat-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;">
                        {{data.kategori_uraian}}
                      </div>
                      <div style="margin-top: -5px;">
                        <q-rating
                        v-model="model1"
                        max="5"
                        size="0.5em"
                        color="purple-12"
                        icon="star_border"
                        icon-selected="star"
                        icon-half="star_half"
                      />
                      </div>
                      <div class="text-center text-no-wrap overflow-hidden produk-android-title" style="text-overflow: ellipsis;">
                        {{ data.brand }}
                      </div>
                      <div v-if="data.diskon == null || data.diskon == 0" class="produk-price1-android">Rp. {{data.harga}}</div>
                      <div v-else class="produk-price1-android">Rp. {{data.harga - (data.harga * data.diskon / 100)}} <span class="produk-price2-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;"> Rp. {{data.harga}}</span></div>
                    </q-card-section>
                    
                  </q-card>
                </div>
              </div>
            </q-tab-panel>
          </q-tab-panels>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ref } from 'vue'
import Header from '@/components/Header.vue'

export default {
  name: 'HomeView',
  props: ['artists'],
  components: {
    Header
  },

  data () {
    return {
      slide: ref(1),
      autoplay: ref(true),
      tab: ref('all'),
      tabs: ref('all'),
      list_banner : [],
      list_kategori : [],
      all_produk : [],
      kategori_produk : [],
      produk_populer : [],
      kategori_populer : [],
      file_path: this.$store.state.url.URL_APP + "uploads/",
    }
  },
  methods: {
    push_produk : function(id){
      this.kirimWa()
      this.$router.push('/produk_detail/'+id);
    },

    kirimWa: function () {

    console.log("DISINI TIDAK SAMPAI KAH");
    console.log(this.$store.state.url.WA);
    fetch(this.$store.state.url.WA, {
    method: "POST",
    headers: {
        "content-type": "application/json",
        'Access-Control-Allow-Origin':'*',
        'Access-Control-Allow-Methods':'POST,PATCH,OPTIONS'
        // authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
        "no_hp" : "082291662895",
        "pesan" : "PESAN INI GAISSS",
        "token" : "wkrkwfbnebfkebfnefdng",
    })
    }).then(res => {
    console.log(res);
    console.log("BERHASIL KIRIM PESAN GAISS");
    });

  },

    getBanner : function(){
      fetch(this.$store.state.url.URL_BERANDA  + "banner", {
          method: "POST",
          headers: {
          "content-type": "application/json"
          }
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_banner = res_data.data;
      });
    },

    getAllProduk : function(){
      fetch(this.$store.state.url.URL_BERANDA  + "allProduk", {
          method: "POST",
          headers: {
          "content-type": "application/json"
          },
      })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
              this.all_produk = res_data.data;
      });
    },

    getKategoriProduk : function(a){
      fetch(this.$store.state.url.URL_BERANDA+"kategoriProduk", {
          method: "POST",
          headers: {
          "content-type": "application/json"
          },
          body: JSON.stringify({
              kategoriId : a
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.kategori_produk = res_data.data;
              console.log(res_data);
      });
    },

    getProdukPopuler : function(){
      fetch(this.$store.state.url.URL_BERANDA  + "produkPopuler", {
          method: "POST",
          headers: {
          "content-type": "application/json"
          },
      })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
              this.produk_populer = res_data.data;
      });
    },

    getKategoriPopuler : function(a){
      fetch(this.$store.state.url.URL_BERANDA+"kategoriPopuler", {
          method: "POST",
          headers: {
          "content-type": "application/json"
          },
          body: JSON.stringify({
              kategoriId : a
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.kategori_populer = res_data.data;
              console.log(res_data);
      });
    },

    getKategori : function (){
      fetch(this.$store.state.url.URL_BERANDA + "listKategori", {
        method: "GET",
        headers: {
          "content-type": "application/json"
        },
      })
      .then(res => res.json())
      .then(res_data => {
        this.list_kategori = res_data;
        console.log(this.list_kategori)
      });
    },
  },
  mounted() {
    this.getBanner();
    this.getAllProduk();
    this.getProdukPopuler();
    this.getKategori();
  }
}
</script>

<style>
.btn-fixed-width {
  width: 200px
}
</style>
